import { route } from 'react-router-typesafe-routes';

export const ROUTES = {
  LOGIN: route({ path: '' }),
  MAP: route({
    path: 'map',
    children: {
      SHAPES: route({ path: 'shapes' }),
      FILTERS: route({ path: 'filters' }),
      REPORTS: route({ path: 'reports' }),
      EVENTS: route({ path: 'events' }),
      REPLAY: route({ path: 'replay' }),
      ATONS: route({ path: 'atons' }),
      MESSAGES: route({ path: 'messages' }),
      PORTADMIN: route({ path: 'portadmin' }),
    },
  }),
  HELP: route({ path: 'help' }),
  POPUP: route({
    path: 'popup',
    children: {
      REPORT: route({ path: 'report' }),
      TARGETS: route({ path: 'targets' }),
    },
  }),
  SETTINGS: route({
    path: 'settings',
    children: {
      GENERAL: route({ path: 'general' }),
      ADMIN: route({ path: 'admin' }),
      THEME: route({ path: 'theme' }),
      MAP: route({ path: 'map' }),
      WEB_MAP_SERVICES: route({ path: 'web-map-services' }),
      VECTOR_TILES: route({ path: 'vector-tiles' }),
      RADAR: route({ path: 'radar' }),
      BASE_MAP: route({ path: 'base-map' }),
      BOOKMARKS: route({ path: 'bookmarks' }),
      CHANGE_PASSWORD: route({ path: 'change-password' }),
      MULTIFACTOR: route({ path: 'multifactor' }),
      NOTIFICATION: route({ path: 'notification' }),
      PORT: route({ path: 'port' }),
      MESSAGES: route({ path: 'messages' }),
      EVENTS: route({ path: 'events' }),
      TARGET: route({ path: 'target' }),
      REPORTS: route({ path: 'reports' }),
      NEXTPORT: route({ path: 'nextport' }),
    },
  }),
  MULTIFACTOR: route({
    path: 'multifactor',
    children: {
      BEFORE_LOGIN: route({ path: 'before-login' }),
      AUTHENTICATED: route({ path: 'authenticated' }),
    },
  }),
  AUTHENTICATION: route({
    path: 'authentication',
    children: {
      CHANGE_PASSWORD: route({ path: 'change-password' }),
    },
  }),
};
